/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: CrudIntegration
 * Reason: Main ObjectBaseComponent for LogicFlow entity — delegates to full or side view based on uiMode. Manages flow status, version, and step loading.
 */
import {Component, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {LogicFlowDto} from "../../../model/dto/entity/logic-flow.dto";
import {LogicFlowStatusEnum} from "../../../enum/logic-flow-status.enum";

@Component({
    selector: 'mvs-lg-logic-flow-object-component',
    templateUrl: './lg-logic-flow-object.component.html',
    standalone: false
})
export class LgLogicFlowObjectComponent extends ObjectBaseComponent {

    dto: LogicFlowDto;
    flowStatus: number = LogicFlowStatusEnum.DRAFT;
    flowVersion: number = 1;
    isPublished: boolean = false;

    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected confirmationService: ConfirmationService,
        protected messageService: MvsMessageService,
        protected observerService: ObserverService,
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onObjectChanged() {
        this.setPageTitle(this.dto.name);
        this.flowStatus = this.dto.flowStatus ?? LogicFlowStatusEnum.DRAFT;
        this.flowVersion = this.dto.version ?? 1;
        this.isPublished = this.flowStatus === LogicFlowStatusEnum.PUBLISHED;
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);

        if (!this.initialized) {
            return;
        }
    }

}
